<template>
	<div>
		<video-bg :sources="['https://sites.appbarber.com.br/assets_site/img/videos/barbershop.mp4']" img="https://sites.appbarber.com.br/assets_site/img/videos/barbershop.png">
			<div class="page-header clear-filter" filter-color="blue">
			<!-- <parallax class="page-header-image" style="background-image:url('https://sites.appbarber.com.br/assets_site/img/videos/barbershop.png')"></parallax> -->
			
				<div class="container ">
					<div class=" content-center brand">
						<h2 style="margin-top: 7em;"><strong>AppBarber</strong></h2>
						<h3><strong>Encontre uma barbearia credenciada próxima a você.</strong></h3>
						
						<div data-background-color="blue" class="card">
							
							<div class="card-body">
								<h4 class="text-black">Por Barbearia</h4>
								<div class="form-group no-border input-group">
									
									<div class="input-group">
										<div class="input-group-prepend">
											<i class="input-group-text now-ui-icons shopping_shop"></i>
										</div>
										<input aria-describedby="addon-right addon-left" placeholder="Barbearia" class="form-control">
									</div>
								</div>
								<hr>
								<h4>Por Cidade</h4>
								
								<div class="form-group no-border input-group">
									<div class="input-group">
										<div class="input-group-prepend">
											<i class="input-group-text now-ui-icons location_pin"></i>
										</div>
										<input aria-describedby="addon-right addon-left" placeholder="Cidade" class="form-control">
									</div>
								</div>
								<div class="card-footer text-center">
									<n-button type="primary" round>
										<i class="fa fa-search"></i> Buscar
									</n-button>
								</div>
							</div>
						</div>
						<div class="row text-center">
							<div class="col-md-12">
								<h3>Baixe o aplicativo nas Stores</h3>
							</div>
							<div class="col-md-6 text-right">
								<a href="https://itunes.apple.com/WebObjects/MZStore.woa/wa/viewSoftware?id=1079972583&mt=8" target="_blank">
									<img src="https://sites.appbarber.com.br/assets_site/icons-stores/icon-applestore.png" alt="applestore">
								</a>
							</div>
							<div class="col-md-6 text-left">
								<a href="https://play.google.com/store/apps/details?id=com.startapp.appbarber" target="_blank">
									<img src="https://sites.appbarber.com.br/assets_site/icons-stores/icon-googleplay.png" alt="applestore">
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</video-bg>
		
		<ListEstabelecimentos></ListEstabelecimentos>
		
	</div>
	
</template>
<script>
	import {
		Parallax,
		Button,
		Modal
	} from '@/components';
	import VideoBg from 'vue-videobg'

	import ListEstabelecimentos from './components/ListEstabelecimentos';

	export default {
		name: 'index',
		bodyClass: 'index-page',
		components: {
			Parallax,
			[Button.name]: Button,
			ListEstabelecimentos,
			VideoBg,
			Modal
		},
		data(){
			return {
				modals: {
					large: false
				},				
				center: { lat: 45.508, lng: -73.587 }
			};
		}
	};
</script>
<style>

</style>